import { render, staticRenderFns } from "./sale.vue?vue&type=template&id=c25edd90"
import script from "./sale.vue?vue&type=script&lang=ts"
export * from "./sale.vue?vue&type=script&lang=ts"
import style0 from "./sale.vue?vue&type=style&index=0&id=c25edd90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports